// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@/assets/css/global.css";
import "babel-polyfill";
import Vue from "vue";
import Root from "./Root";
import router from "./router";
import VueResource from "vue-resource";

Vue.config.productionTip = false;

Vue.use(VueResource);
Vue.http.options.emulateJSON = true;

/* eslint-disable no-new */
new Vue({
  el: document.querySelector("#root"),
  router,
  components: { Root },
  template: "<Root/>",
});



// WEBPACK FOOTER //
// ./src/main.js